import { css, cx } from "styled-system/css";
import type { TextareaHTMLAttributes } from "react";

const field = css({
  width: "100%",
  px: "3",
  py: "2",
  rounded: "md",
  borderWidth: "1px",
  borderColor: "border.DEFAULT",
  bg: "bg.DEFAULT",
  color: "fg.DEFAULT",
  fontSize: "sm",
  fontFamily: "inherit",
  resize: "vertical",
  _placeholder: { color: "fg.muted" },
  _focus: { outline: "none", borderColor: "accent.DEFAULT", boxShadow: "0 0 0 1px token(colors.brand.500)" },
});

export function Textarea({ className, ...props }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea className={cx(field, className)} {...props} />;
}
